import { useCalculatorStore } from '@/store/calculatorStore'
import * as Sentry from '@sentry/react'

declare global {
  interface Window {
    Intercom: (
      command: 'update' | 'showNewMessage',
      options: { karakterKalkulatorUrl?: string } | string
    ) => void
  }
}

function useOpenIntercomChat() {
  const state = useCalculatorStore((state) => state)

  return () => {
    Sentry.startSpan(
      {
        op: 'ui.click',
        name: 'Open Intercom Chat',
      },
      (span) => {
        span.setAttribute('uuid', state.uuid)

        try {
          window.Intercom('update', {
            karakterKalkulatorUrl: `https://www.askprivatist.no/karakterkalkulator?uuid=${state.uuid}`,
          })
          window.Intercom(
            'showNewMessage',
            `Hei, jeg trenger veiledning ang:\n https://www.askprivatist.no/karakterkalkulator?uuid=${state.uuid}`
          )

          span.setAttribute('success', true)
        } catch (e) {
          span.setAttribute('success', false)
          Sentry.captureException(e, {
            tags: {
              component: 'IntercomChat',
              action: 'openChat',
            },
            extra: {
              uuid: state.uuid,
            },
          })
        }
      }
    )
  }
}

export default useOpenIntercomChat
